<template>
  <div class="top-bar">
    <div
      class="container d-flex flex-column flex-md-row justify-content-center align-items-center"
    >
      <div class="align-items-center company-info-container">
        <img
          src="/maia.png"
          alt="Logo Maia Produção de Softwares"
          class="logo me-3"
        />
      </div>
      <div>
        <h1 class="company-info text-white m-0 d-md-block">
          Maia Produção de Softwares
        </h1>
        <p
          class="contact-info text-white m-0 mt-2 mt-md-0 d-flex flex-column flex-md-row align-items-center"
        >
          <AutoTyperVue
            v-if="type"
            componentTag="span"
            :waitBeforeDeleteDelay="1000"
            :removeAfterRepeat="false"
            :betweenWordDelay="90"
            :typingDelay="20"
            :deletingDelay="10"
            :text="strings"
          />
        </p>
        <small
          class="contact-info d-flex flex-column flex-md-row align-items-center"
        >
          {{ $t('message.since1999') }}
        </small>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { AutoTyperVue } from 'auto-typer-vue3'
import { language, languageManuallySelected } from '@/plugins/i18n'
const { t } = useI18n()

const type = ref(true)

watch(language, (newLang, oldLang) => {
  if (newLang !== oldLang && languageManuallySelected.value) {
    type.value = false
    setTimeout(() => {
      type.value = true
    }, 1)
  }
})

const strings = computed(() => [
  t('message.topBar.excellence'),
  t('message.topBar.transforming'),
  t('message.topBar.experience'),
])
</script>

<style scoped>
.top-bar {
  background-color: #498fd2;
  padding: 35px 10px;
  width: 100%;
  z-index: 1;
  position: relative;
}

small {
  color: #495057 !important;
}

.top-bar .container {
  min-height: 100px;
}

.top-bar h1 {
  font-size: 2.3rem;
  font-weight: 600;
}

.top-bar p {
  font-size: 1.2rem;
  font-weight: 400;
  min-height: 2.4rem;
  margin-bottom: 0px;
}

.icon {
  height: 25px;
}

.logo {
  height: 85px;
}

@media (max-width: 767px) {
  .company-info {
    text-align: center;
    margin-bottom: 10px;
  }
  .contact-info {
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
  }
  .contact-info p {
    flex-basis: 100%;
    margin: 5px 0;
  }
  .logo {
    margin-bottom: 15px;
  }
}
</style>
